import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { VerifyLoginCredential } from "../../services/Login/LoginApi";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import SuryaLogoMain from "../../assets/images/jobmongo-logo-full.png";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";

const Login = () => {
  const { setLoginItem, validateEmail } = useContext(AuthContext);
  const navigate = useNavigate();
  const { setLoader } = useContext(LoaderContext);
  const [showPassword, setShowPassword] = useState(false);
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [LoginObj, setLoginObj] = useState({
    emailID: "",
    password: "",
    ipAddress: "",
  });
  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        // setIpAddress(data.ip);
        setLoginObj({
          ...LoginObj,
          ipAddress: data.ip,
        });
        console.log(data.ip, "IP Address");
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIp();
  }, []);
  const LoginBtnClicked = async () => {
    if (
      LoginObj.emailID === "" ||
      LoginObj.emailID === null ||
      LoginObj.emailID === undefined ||
      LoginObj.password === "" ||
      LoginObj.password === null ||
      LoginObj.password === undefined ||
      ((LoginObj.emailID || "").length > 0 && !validateEmail(LoginObj.emailID))
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    try {
      setLoader(true);
      const data = await VerifyLoginCredential({
        emailID: LoginObj.emailID,
        password: LoginObj.password,
        ipAddress: LoginObj.ipAddress,
      });

      if (data?.statusCode === 200) {
        setLoader(false);
        localStorage.setItem(
          "login",
          JSON?.stringify(data?.responseData?.data)
        );
        setLoginItem(data?.responseData?.data);
        navigate("/"); // Navigate immediately on button click
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen px-4">
      <div className="bg-white border border-gray-300 shadow-lg p-4 sm:p-6 md:p-8 rounded-lg w-full sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3">
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img alt="Logo" src={SuryaLogoMain} className="w-1/3 sm:w-1/4" />
        </div>

        {/* Title */}
        <div className="text-center font-semibold text-2xl mb-6">Log In</div>
        {ErrorMessage && (
          <div className="validation mb-4 text-center">{ErrorMessage}</div>
        )}

        {/* Email Field */}
        <div className="mb-4">
          <label className="block font-medium text-gray-700 mb-2">Email</label>
          <input
            type="email"
            className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Email ID"
            value={LoginObj.emailID}
            onChange={(e) =>
              setLoginObj({ ...LoginObj, emailID: e.target.value.trim() })
            }
          />
          {requireErrorMessage &&
          (!LoginObj.emailID || LoginObj.emailID.trim() === "") ? (
            <label className="validation">{ERROR_MESSAGES}</label>
          ) : (
            LoginObj.emailID?.length > 0 &&
            !validateEmail(LoginObj.emailID) && (
              <label className="validation text-red-500 text-sm">
                Invalid email format
              </label>
            )
          )}
        </div>

        {/* Password Field */}
        <div className="mb-6">
          <label className="block font-medium text-gray-700 mb-2">
            Password
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              className="p-3 pr-10 border rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder="Enter Password"
              maxLength={20}
              value={LoginObj.password}
              onChange={(e) =>
                setLoginObj({ ...LoginObj, password: e.target.value.trim() })
              }
            />
            <button
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
              type="button"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          {requireErrorMessage && !LoginObj.password ? (
            <label className="validation">{ERROR_MESSAGES}</label>
          ) : (
            ""
          )}
        </div>

        {/* Login Button */}
        <div className="text-center">
          <button
            className="p-3 w-full text-white bg-orange-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            type="button"
            onClick={LoginBtnClicked}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
